// These CSS classes should probably be components of some sort.

import { css } from "@microsoft/fast-element";

export const miniComponents = css`
    .natgen-banner {
        background: var(--ui-banner-color-background);
        color: var(--ui-banner-color-text);
        font-weight: var(--ui-banner-typography-font-weight);
    }
`
